import { DocumentItem, SubEntityType } from '../../models';
import { knowledgeBaseHttp } from '../knowledge-base-api';

export const getFilteredDocuments = async (
  groupIds: number[],
  locale: string,
  documentTypes?: string[]
): Promise<DocumentItem[]> => {
  if (!groupIds.length) return [];

  const SEPARATOR = '|';
  let url = `/groups/${SubEntityType.Documents}?ids=${groupIds.join(SEPARATOR)}&marketLocale=${encodeURIComponent(locale)}`;

  if (documentTypes && documentTypes.length > 0) {
    url += `&types=${documentTypes.join(SEPARATOR)}`;
  }

  const response = await knowledgeBaseHttp.get<DocumentItem[]>(url);
  return response?.data ?? [];
};
